import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { NavbarVariantType } from '../../../../../components/navbar/types/navbar';
import { NavbarStateType } from '../../../../../components/navbar/types/state';
import { FONT_WEIGHT } from '../../foundations/typography';
export const getNavbarStyles = (FOUNDATIONS, FONT) => {
    return {
        [NavbarVariantType.DEFAULT]: {
            container: {
                position: 'relative',
                width: '100%',
                display: 'flex',
                flex_direction: 'column',
                justify_content: 'space-between',
                padding: `${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_250}`,
                background_color: FOUNDATIONS.color_neutral_bg_375,
            },
            optionContainer: {
                display: 'flex',
                flex_direction: 'row',
                justify_content: 'space-between',
                gap: FOUNDATIONS.spacing_100,
            },
            optionContent: {
                display: 'flex',
                flex_direction: 'column',
                align_items: 'center',
                gap: FOUNDATIONS.spacing_50,
            },
            animation: {
                duration: FOUNDATIONS.duration_200,
                delay: FOUNDATIONS.duration_50,
            },
            [NavbarStateType.DEFAULT]: {
                optionIcon: {
                    color: FOUNDATIONS.color_accent_disabled_icon_50,
                    width: FOUNDATIONS.size_300,
                    height: FOUNDATIONS.size_300,
                },
                optionLabel: {
                    color: FOUNDATIONS.color_accent_disabled_font_50,
                    font_size: FONT.font_paragraph_650[DeviceBreakpointsType.DESKTOP].font_size,
                    line_height: FONT.font_paragraph_650[DeviceBreakpointsType.DESKTOP].line_height,
                    font_weight: FONT_WEIGHT.font_regular,
                },
                lineContainer: {
                    height: FOUNDATIONS.spacing_50,
                    width: FOUNDATIONS.size_200,
                    background_color: FOUNDATIONS.color_brand_bg_50,
                },
            },
            [NavbarStateType.SELECTED]: {
                optionIcon: {
                    color: FOUNDATIONS.color_brand_icon_100,
                    width: FOUNDATIONS.size_300,
                    height: FOUNDATIONS.size_300,
                },
                optionLabel: {
                    color: FOUNDATIONS.color_neutral_font_50,
                    font_size: FONT.font_paragraph_700[DeviceBreakpointsType.DESKTOP].font_size,
                    line_height: FONT.font_paragraph_700[DeviceBreakpointsType.DESKTOP].line_height,
                    font_weight: FONT_WEIGHT.font_bold,
                },
                lineContainer: {
                    display: 'flex',
                    flex_direction: 'row',
                    gap: FOUNDATIONS.spacing_100,
                    width: '100%',
                    height: '1px',
                    background_color: FOUNDATIONS.color_brand_bg_50,
                },
            },
        },
    };
};
//# sourceMappingURL=styles.js.map